import type CalendarViewRouteType from '../schema/CalendarViewRouteType';
import { getSelectedViewType } from '../selectors/getSelectedViewType';
import { getCalendarViewRouteFromType } from '../utils/getCalendarViewRouteFromType';

export function getCalendarRoutePath(): CalendarViewRouteType {
    return getCalendarViewRouteFromType(getSelectedViewType());
}
